export default [
  {
    header: '—— ข้อมูลส่วนตัว ——',
    resource: 'normal',
    action: 'manage',
  },
  {
    title: 'เชื่อมต่อ',
    route: 'connect',
    icon: 'LinkIcon',
  },
  {
    title: 'คูปองของฉัน',
    route: 'me-coupon',
    icon: 'GiftIcon',
  },
  {
    title: 'ที่อยู่จัดส่ง',
    route: 'me-address',
    icon: 'TruckIcon',
  },
  {
    title: 'ข้อมูลทั่วไป',
    route: 'me-information',
    icon: 'UserIcon',
  },
]
